import { getEmptyMandatoryOrFieldsWithError, getSortFields } from 'apps/auth/components/form-multi/utils';
import {
    CALCULATOR_SCREEN,
    PHONE_SCREEN,
    REQUEST_ADDITIONAL_FIELDS,
    REQUEST_DELIVERY_METHODS,
    REQUEST_NEW_ACCOUNT,
    REQUEST_NEW_CARD,
} from 'apps/auth/components/request/RequestConstants';
import { AMOUNT_TO, PHONE } from 'apps/auth/constants/fieldsName';
import { CVV, EXP_DATE, PAN } from 'apps/auth/constants/FieldType';

type FormField = {
    visible?: boolean;
    destination?: string;
    type?: string;
    [key: string]: unknown;
};

type FieldsMap = Record<string, FormField>;

export const checkFromField = (field?: FormField): boolean => {
    return !!(field?.visible && field?.destination === 'FROM' && field?.type !== PAN && field?.type !== CVV && field?.type !== EXP_DATE);
};

const getFromFields = (fields: FieldsMap, showFromFields: boolean, showPaymentFields: boolean): FormField[] => {
    const visibleFields: FormField[] = [];
    (getSortFields(fields) as FormField[]).forEach((field) => {
        const isFromField = field.visible && field.destination === 'FROM';
        const isCardField = field.type === PAN || field.type === CVV || field.type === EXP_DATE;
        if ((showFromFields && isFromField && !isCardField) || (showPaymentFields && isCardField)) {
            visibleFields.push(field);
        }
    });
    return visibleFields;
};

export const hasDynamicButton = (currentScreen: string, isCreate: boolean): boolean => {
    switch (currentScreen) {
        case PHONE_SCREEN:
            return !!isCreate;
        case REQUEST_ADDITIONAL_FIELDS:
        case REQUEST_NEW_ACCOUNT:
        case REQUEST_NEW_CARD:
            return true;
        default:
            return false;
    }
};

export class GTRequestMultiScreenService {
    #screenCounter = -1;

    setScreenCounter(num: number): void {
        this.#screenCounter = num;
    }

    goAHeadScreen(): void {
        this.#screenCounter--;
    }

    goBackScreen(): void {
        this.#screenCounter++;
    }

    isFinalScreen(): boolean {
        return this.#screenCounter === 0;
    }

    static toggleContinueButton(fields: FieldsMap, currentScreen: string, toggleContinueButton: (disabled: boolean) => void): void {
        if (currentScreen === REQUEST_DELIVERY_METHODS) {
            toggleContinueButton(false);
        } else {
            toggleContinueButton(getEmptyMandatoryOrFieldsWithError(this.getVisibleFields(fields, currentScreen), true, false)?.length > 0);
        }
    }

    static getVisibleFields(fields: FieldsMap, currentScreen: string): FormField[] {
        let screenFields: FormField[] = [];
        if (currentScreen === PHONE_SCREEN) {
            screenFields.push(fields[PHONE]);
        } else if (currentScreen === CALCULATOR_SCREEN) {
            screenFields.push(fields[AMOUNT_TO]);
        } else if (currentScreen === REQUEST_NEW_CARD) {
            screenFields = getFromFields(fields, false, true);
        } else if (currentScreen === REQUEST_ADDITIONAL_FIELDS) {
            const sortedFields = getSortFields(fields) as FormField[];
            screenFields = getFromFields(fields, true, false).concat(sortedFields.filter((f) => f?.visible && 'TO' === f?.destination));
        }
        return screenFields;
    }
}
